import { render } from "./underwritters-config.vue?vue&type=template&id=8f31f956&lang=html"
import script from "./underwritters-config.vue?vue&type=script&lang=js"
export * from "./underwritters-config.vue?vue&type=script&lang=js"

import "./underwritters-config.vue?vue&type=style&index=0&id=8f31f956&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__